import { Icon } from './Icon';

type IconProps = {
  color?: string;
  size?: string;
};

export const CheckIcon: React.FC<IconProps> = ({ color, size }) => {
  return (
    <Icon color={color} size={size}>
      <path
        className="transition duration-300 ease-in-out"
        d="M16.8945 7.04688L9.70312 14.2383L7.07812 11.5859C6.94141 11.4766 6.72266 11.4766 6.61328 11.5859L5.82031 12.3789C5.71094 12.4883 5.71094 12.707 5.82031 12.8438L9.48438 16.4805C9.62109 16.6172 9.8125 16.6172 9.94922 16.4805L18.1523 8.27734C18.2617 8.16797 18.2617 7.94922 18.1523 7.8125L17.3594 7.04688C17.25 6.91016 17.0312 6.91016 16.8945 7.04688Z"
      />
    </Icon>
  );
};
